import { render, staticRenderFns } from "./CreateCourseView.vue?vue&type=template&id=36805026&"
import script from "./CreateCourseView.vue?vue&type=script&lang=js&"
export * from "./CreateCourseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports